import { Reducer } from 'redux'
import { CloudMarketplace, ProductStatus } from '../productsListing/reducer'
import { RawValue, setItem } from '../../../common/utils/localStorage'

export enum FlyoutFunction {
  'REVENUE' = 'revenue',
  'PRIVATE_OFFERS' = 'privateOffers',
  'RESALE_AUTHORIZATIONS' = 'resaleAuthorizations',
  'SUBSCRIPTION' = 'subscription',
}

export enum ProductListingFilterType {
  SET_CLOUD_MARKETPLACE = 'SET_CLOUD_MARKETPLACE',
  SET_CREATE_PRIVATE_OFFER_MODAL_OPEN = 'SET_CREATE_PRIVATE_OFFER_MODAL_OPEN',
}

export const notAllowedProductSelection = [
  ProductStatus.PRODUCT_STATUS_DRAFT,
  ProductStatus.PRODUCT_STATUS_IN_PROGRESS,
  ProductStatus.PRODUCT_STATUS_CREATION_FAILED,
]

export interface ProductListingFilters {
  cloudMarketplace: CloudMarketplace
  createPrivateOfferModalOpen: boolean
}

//getInitalCloudMarketplace will check first cloudType from url if it's present then use this [used while link open from hubspot or email]
//if not in then check fomm localstorage if got then use that
//else default AWS will use.

const getInitalCloudMarketplace = (): CloudMarketplace => {
  try {
    // Check URL params first
    if (typeof window !== 'undefined' && window.location) {
      const urlParams = new URLSearchParams(window.location.search)
      const cloudTypeFromUrl = urlParams.get('cloudType')
      if (cloudTypeFromUrl) {
        return cloudTypeFromUrl as CloudMarketplace
      }
    }

    // Check localStorage
    if (typeof localStorage !== 'undefined') {
      const fromLocal = localStorage.getItem('cloudType')
      if (fromLocal) {
        try {
          const parsed = JSON.parse(fromLocal) as RawValue
          if (parsed?.value) {
            return parsed.value as CloudMarketplace
          }
        } catch {
          // If JSON parsing fails, fall through to default
        }
      }
    }
  } catch {
    // If any error occurs, fall through to default
  }

  // Default fallback
  return 'AWS'
}

type actionType =
  | {
      type: ProductListingFilterType.SET_CLOUD_MARKETPLACE
      payload: CloudMarketplace
    }
  | {
      type: ProductListingFilterType.SET_CREATE_PRIVATE_OFFER_MODAL_OPEN
      payload: boolean
    }
export const initialState: ProductListingFilters = {
  cloudMarketplace: getInitalCloudMarketplace(),
  createPrivateOfferModalOpen: false,
}
export const reducer: Reducer<ProductListingFilters, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ProductListingFilterType.SET_CLOUD_MARKETPLACE: {
      setItem('cloudType', action.payload)
      return {
        ...state,
        cloudMarketplace: action.payload,
      }
    }
    case ProductListingFilterType.SET_CREATE_PRIVATE_OFFER_MODAL_OPEN: {
      return {
        ...state,
        createPrivateOfferModalOpen: action.payload,
      }
    }
    default: {
      return state
    }
  }
}
